import { type WorkspaceMemberResponseWithRoles } from '@air/api/types';

export const isActiveMember = (member: WorkspaceMemberResponseWithRoles) => !member.inactive && !member.pending;

export const isGuest = (member: WorkspaceMemberResponseWithRoles) => member.roles.guest.length > 0;
